import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconCardOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M25 24h-4c-1.72 0-3-1.28-3-3s1.28-3 3-3h4c1.72 0 3 1.28 3 3s-1.28 3-3 3m-4-4c-.74 0-1 .52-1 1s.26 1 1 1h4c.74 0 1-.52 1-1s-.26-1-1-1z" /><path fill="currentColor" d="M29.6 4H2.4C1.08 4 0 5.06 0 6.4v19.2C0 26.92 1.08 28 2.4 28h27.2c1.32 0 2.4-1.08 2.4-2.4V6.4C32 5.06 30.92 4 29.6 4m.4 21.6c0 .2-.18.4-.4.4H2.4c-.22 0-.4-.2-.4-.4V12h28zM2 10V6.4c0-.22.18-.4.4-.4h27.2c.22 0 .4.18.4.4V10z" /></svg>;
export default SvgIconCardOutlined;